/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import { kawulStat } from "./irregular-conjugations";
export var presentEndings = [[[{
  p: "م",
  f: "um"
}], [{
  p: "و",
  f: "oo"
}]], [[{
  p: "م",
  f: "um"
}], [{
  p: "و",
  f: "oo"
}]], [[{
  p: "ې",
  f: "e"
}], [{
  p: "ئ",
  f: "eyy"
}]], [[{
  p: "ې",
  f: "e"
}], [{
  p: "ئ",
  f: "eyy"
}]], [[{
  p: "ي",
  f: "ee"
}], [{
  p: "ي",
  f: "ee"
}]], [[{
  p: "ي",
  f: "ee"
}], [{
  p: "ي",
  f: "ee"
}]]];
export var pastEndings = [[[{
  p: "م",
  f: "um"
}], [{
  p: "و",
  f: "oo"
}]], [[{
  p: "م",
  f: "um"
}], [{
  p: "و",
  f: "oo"
}]], [[{
  p: "ې",
  f: "e"
}], [{
  p: "ئ",
  f: "eyy"
}]], [[{
  p: "ې",
  f: "e"
}], [{
  p: "ئ",
  f: "eyy"
}]], [[{
  p: "ه",
  f: "u"
}, {
  p: "و",
  f: "o"
}], [{
  p: "ل",
  f: "ul"
}]], [[{
  p: "ه",
  f: "a"
}], [{
  p: "ې",
  f: "e"
}]]]; // TODO: MAKE THIS VARIABLE FOR DIALECTS!

export var aayTail = {
  p: "ی",
  f: "ey"
};
export var subjPastEquative = {
  p: "و" + aayTail.p,
  f: "w" + aayTail.f
};
export var equativeEndings = {
  past: {
    short: [[[{
      p: "وم",
      f: "wum"
    }], [{
      p: "وو",
      f: "woo"
    }]], [[{
      p: "وم",
      f: "wum"
    }], [{
      p: "وو",
      f: "woo"
    }]], [[{
      p: "وې",
      f: "we"
    }], [{
      p: "وئ",
      f: "weyy"
    }]], [[{
      p: "وې",
      f: "we"
    }], [{
      p: "وئ",
      f: "weyy"
    }]], [[{
      p: "و",
      f: "wo"
    }], [{
      p: "ول",
      f: "wul"
    }, {
      p: "وو",
      f: "woo"
    }]], [[{
      p: "وه",
      f: "wa"
    }], [{
      p: "وې",
      f: "we"
    }]]],
    long: [[[{
      p: "ولم",
      f: "wulum"
    }], [{
      p: "ولو",
      f: "wuloo"
    }]], [[{
      p: "ولم",
      f: "wulum"
    }], [{
      p: "ولو",
      f: "wuloo"
    }]], [[{
      p: "ولې",
      f: "wule"
    }], [{
      p: "ولئ",
      f: "wuleyy"
    }]], [[{
      p: "ولې",
      f: "wule"
    }], [{
      p: "ولئ",
      f: "wuleyy"
    }]], [[{
      p: "ولو",
      f: "wulo"
    }], [{
      p: "ول",
      f: "wul"
    }, {
      p: "ولو",
      f: "wuloo"
    }]], [[{
      p: "وله",
      f: "wula"
    }], [{
      p: "ولې",
      f: "wule"
    }]]]
  },
  present: [[[{
    p: "یم",
    f: "yum"
  }], [{
    p: "یو",
    f: "yoo"
  }]], [[{
    p: "یم",
    f: "yum"
  }], [{
    p: "یو",
    f: "yoo"
  }]], [[{
    p: "یې",
    f: "ye"
  }], [{
    p: "یئ",
    f: "yeyy"
  }]], [[{
    p: "یې",
    f: "ye"
  }], [{
    p: "یئ",
    f: "yeyy"
  }]], [[{
    p: "دی",
    f: "dey"
  }], [{
    p: "دي",
    f: "dee"
  }]], [[{
    p: "ده",
    f: "da"
  }], [{
    p: "دي",
    f: "dee"
  }]]],
  subjunctive: [[[{
    p: "یم",
    f: "yum"
  }], [{
    p: "یو",
    f: "yoo"
  }]], [[{
    p: "یم",
    f: "yum"
  }], [{
    p: "یو",
    f: "yoo"
  }]], [[{
    p: "یې",
    f: "ye"
  }], [{
    p: "یئ",
    f: "yeyy"
  }]], [[{
    p: "یې",
    f: "ye"
  }], [{
    p: "یئ",
    f: "yeyy"
  }]], [[{
    p: "وي",
    f: "wee"
  }], [{
    p: "وي",
    f: "wee"
  }]], [[{
    p: "وي",
    f: "wee"
  }], [{
    p: "وي",
    f: "wee"
  }]]],
  hypothetical: [[[subjPastEquative], [subjPastEquative]], [[subjPastEquative], [subjPastEquative]], [[subjPastEquative], [subjPastEquative]], [[subjPastEquative], [subjPastEquative]], [[subjPastEquative], [subjPastEquative]], [[subjPastEquative], [subjPastEquative]]]
};
export var emptyVerbBlock = [[[{
  p: "",
  f: ""
}], [{
  p: "",
  f: ""
}]], [[{
  p: "",
  f: ""
}], [{
  p: "",
  f: ""
}]], [[{
  p: "",
  f: ""
}], [{
  p: "",
  f: ""
}]], [[{
  p: "",
  f: ""
}], [{
  p: "",
  f: ""
}]], [[{
  p: "",
  f: ""
}], [{
  p: "",
  f: ""
}]], [[{
  p: "",
  f: ""
}], [{
  p: "",
  f: ""
}]]];
export var imperativeEndings = [// masc 2nd pers
[[{
  p: "ه",
  f: "a"
}], [{
  p: "ئ",
  f: "eyy"
}] // plural
], // fem 2nds pers
[[{
  p: "ه",
  f: "a"
}], [{
  p: "ئ",
  f: "eyy"
}] // plural
]];
export var ooPrefix = {
  p: "و",
  f: "oo"
};
export var baParticle = {
  p: "به",
  f: "ba"
};
export var presentParticipleSuffix = {
  p: "ونکی",
  f: "oonkey"
};
var adjEndingsBlock = [// singular                   plural
[[{
  p: "\u06CC",
  f: "ey"
}], [{
  p: "\u064A",
  f: "ee"
}]], [[{
  p: "\u06D0",
  f: "e"
}], [{
  p: "\u06D0",
  f: "e"
}]] // female
];
export var adjectiveEndings = [].concat(adjEndingsBlock, adjEndingsBlock, adjEndingsBlock);
var ksPerf = kawulStat.info.root.perfective;
export var passiveStativeBridge = [// TODO: SHORT AND LONG HERE??
{
  short: ksPerf.long,
  long: ksPerf.long
}, {
  short: {
    p: ksPerf.short.p + aayTail.p,
    f: ksPerf.short.f + aayTail.f
  },
  long: {
    p: ksPerf.long.p + aayTail.p,
    f: ksPerf.long.f + aayTail.f
  }
}];
var basePlainPronouns = [[[{
  p: "زه",
  f: "zu"
}], [{
  p: "مونږ",
  f: "moonG"
}, {
  p: "موږ",
  f: "mooG"
}]], [[{
  p: "زه",
  f: "zu"
}], [{
  p: "مونږ",
  f: "moonG"
}, {
  p: "موږ",
  f: "mooG"
}]], [[{
  p: "ته",
  f: "tu"
}], [{
  p: "تاسو",
  f: "táaso"
}, {
  p: "تاسې",
  f: "táase"
}]], [[{
  p: "ته",
  f: "tu"
}], [{
  p: "تاسو",
  f: "táaso"
}, {
  p: "تاسې",
  f: "táase"
}]]];
var baseInflectedPronouns = [[[{
  p: "ما",
  f: "maa"
}], [{
  p: "مونږ",
  f: "moonG"
}, {
  p: "موږ",
  f: "mooG"
}]], [[{
  p: "ما",
  f: "maa"
}], [{
  p: "مونږ",
  f: "moonG"
}, {
  p: "موږ",
  f: "mooG"
}]], [[{
  p: "تا",
  f: "taa"
}], [{
  p: "تاسو",
  f: "táaso"
}, {
  p: "تاسې",
  f: "táase"
}]], [[{
  p: "تا",
  f: "taa"
}], [{
  p: "تاسو",
  f: "táaso"
}, {
  p: "تاسې",
  f: "táase"
}]]];
var plainPronounsFar = [].concat(basePlainPronouns, [[[{
  p: "هغه",
  f: "haghá"
}], [{
  p: "هغوي",
  f: "haghwée"
}]], [[{
  p: "هغه",
  f: "haghá"
}], [{
  p: "هغوي",
  f: "haghwée"
}]]]);
var plainPronounsNear = [].concat(basePlainPronouns, [[[{
  p: "دی",
  f: "dey"
}], [{
  p: "دوي",
  f: "dwee"
}]], [[{
  p: "دا",
  f: "daa"
}], [{
  p: "دوي",
  f: "dwee"
}]]]);
var inflectedPronounsFar = [].concat(baseInflectedPronouns, [[[{
  p: "هغهٔ",
  f: "haghú"
}], [{
  p: "هغوي",
  f: "haghwée"
}]], [[{
  p: "هغې",
  f: "haghé"
}], [{
  p: "هغوي",
  f: "haghwée"
}]]]);
var inflectedPronounsNear = [].concat(baseInflectedPronouns, [[[{
  p: "دهٔ",
  f: "du"
}], [{
  p: "دوي",
  f: "dwee"
}]], [[{
  p: "دې",
  f: "de"
}], [{
  p: "دوي",
  f: "dwee"
}]]]);
var miniPronouns = [[[{
  p: "مې",
  f: "me"
}], [{
  p: "مو",
  f: "mU"
}]], [[{
  p: "مې",
  f: "me"
}], [{
  p: "مو",
  f: "mU"
}]], [[{
  p: "دې",
  f: "de"
}], [{
  p: "مو",
  f: "mU"
}]], [[{
  p: "دې",
  f: "de"
}], [{
  p: "مو",
  f: "mU"
}]], [[{
  p: "یې",
  f: "ye"
}], [{
  p: "یې",
  f: "ye"
}]], [[{
  p: "یې",
  f: "ye"
}], [{
  p: "یې",
  f: "ye"
}]]];
export var pronouns = {
  far: {
    plain: plainPronounsFar,
    inflected: inflectedPronounsFar
  },
  near: {
    plain: plainPronounsNear,
    inflected: inflectedPronounsNear
  },
  mini: miniPronouns
};
export var persons = [{
  label: {
    subject: "I (m.)",
    object: "me (m.)"
  },
  person: 0
}, {
  label: {
    subject: "I (f.)",
    object: "me (f.)"
  },
  person: 1
}, {
  label: {
    subject: "You (m.)",
    object: "you (m.)"
  },
  person: 2
}, {
  label: {
    subject: "You (f.)",
    object: "you (f.)"
  },
  person: 3
}, {
  label: {
    subject: "He/it (m.)",
    object: "him/it (m.)"
  },
  person: 4
}, {
  label: {
    subject: "She/it (f.)",
    object: "her/it (f.)"
  },
  person: 5
}, {
  label: {
    subject: "We (m. pl.)",
    object: "us (m. pl.)"
  },
  person: 6
}, {
  label: {
    subject: "We (f. pl.)",
    object: "us (f. pl.)"
  },
  person: 7
}, {
  label: {
    subject: "You (m. pl.)",
    object: "you (m. pl.)"
  },
  person: 8
}, {
  label: {
    subject: "You (f. pl.)",
    object: "you (f. pl.)"
  },
  person: 9
}, {
  label: {
    subject: "They (m. pl.)",
    object: "them (m. pl.)"
  },
  person: 10
}, {
  label: {
    subject: "They (f. pl.)",
    object: "them (f. pl.)"
  },
  person: 11
}];